window.addEventListener('DOMContentLoaded', function() {
	if(document.querySelector('.calendly-inline-widget') && !document.querySelector('script[src="https://assets.calendly.com/assets/external/widget.js"]')) {
		
		const script = document.createElement("script")
		script.src = 'https://assets.calendly.com/assets/external/widget.js'
		document.body.appendChild(script)
	}
	
})